import FooterMethod from './FooterMethod';

export default FooterMethod;